import { render } from "./main-layout.vue?vue&type=template&id=b1b2e236&scoped=true"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"

import "./main-layout.vue?vue&type=style&index=0&id=b1b2e236&scoped=true&lang=css"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b2e236"]])

export default __exports__